(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('AccessDeniedController', AccessDeniedController);

    AccessDeniedController.$inject = ['$state', 'Auth', 'Principal'];

    // SUP-12293: an account left with no role is told so, and offered to sign out instead of a way back to a page it
    // cannot open
    function AccessDeniedController($state, Auth, Principal) {
        var vm = this;

        vm.noAccess = Principal.hasNoAccess();
        vm.logout = logout;

        // the page can open while the identity is being reloaded (after a sign-in); decide once it is known
        Principal.identity().then(function () {
            vm.noAccess = Principal.hasNoAccess();
        });

        function logout() {
            Auth.logout();
            $state.go('landing-page');
        }
    }
})();
